import PropTypes from "prop-types";

export const pageHeadingProps = {
  heading: PropTypes.string.isRequired,
  location: PropTypes.string,
};
